/**
 * Alert users about unsaved form data when leaving the page
 */
(function($) {
    'use strict';

    // Track if form has been modified
    let formModified = false;
    let formSubmitted = false;

    $(document).ready(function() {
        const $form = $('.wpcf7-form');

        if (!$form.length) {
            return;
        }

        // Track form changes
        $form.on('input change', 'input, textarea, select', function() {
            // Don't track if form has already been submitted
            if (!formSubmitted) {
                formModified = true;
            }
        });

        // Reset flag when form is successfully submitted
        document.addEventListener('wpcf7mailsent', function(event) {
            formSubmitted = true;
            formModified = false;
        }, false);

        // Show warning when user tries to leave the page
        window.addEventListener('beforeunload', function(e) {
            if (formModified && !formSubmitted) {
                // Standard way to trigger the browser's confirmation dialog
                e.preventDefault();
                // Chrome requires returnValue to be set
                e.returnValue = '';
                // Some browsers display this message (most modern browsers use a generic message)
                return 'You have unsaved changes. Are you sure you want to leave?';
            }
        });
    });

})(jQuery);
